(function() {
  'use strict';

  angular.module('eclipseApp.core').directive('paymentOptions', [
    'bankCodes',
    'buyUtils',
    'uteSemafoneService',
    'buyService',
    '$translate',
    'dtmService',
    'dtmServiceConstants',
    function(bankCodes, buyUtils, uteSemafoneService, buyService, $translate, dtmService, dtmServiceConstants) {
      return {
        restrict: 'A',
        scope: {
          props: '=formProps', // expose form data outside the directive
          rootForm: '=poRootForm', // mandatory for setting invalidity of form
          config: '=poConfig', // TBD
          mixins: '=mixins',
          hasBeenSubmitted: '=',
          addNewClass: '=',

          /*
           * @isolate scope.data
           * Use for exposing data into the directive from outside controller;
           *
           * Being used in buy-flow;
           *
           */

          data: '=poDataIn',
          delegate: '=poDelegate', // set specific behaviour depending on the flow the directive is used ex: buyFlow or myAccount:changePaymentMethod
          dtmName: '=dtmName'
        },
        replace: true,
        templateUrl: 'modules/core/views/payment-options-directive.html',
        compile: function() {
          return function($scope, $elem, $attr) {
            $scope.acknowledge = false;
            $scope.clicked = false;
            $scope.isNotValidCard = false;

            $scope.accepted = function() {
              angular.element('.ute-input-textarea').bind('scroll', function() {
                var offset = $('.read-only').offset().top + $('.read-only').height();
                var top = $('.read-only div').offset().top + $('.read-only div').height() - offset;

                console.log(top);
                if (top <= 100 && $scope.acknowledge == false) {
                  $scope.$apply(function() {
                    $scope.acknowledge = true;
                  });
                }
              });

              $scope.clicked = true;

              var offset = $('.read-only').offset().top + $('.read-only').height();
              var top = $('.read-only div').offset().top + $('.read-only div').height() - offset;

              if (top <= 100 && $scope.acknowledge == false) {
                $scope.acknowledge = true;
              }
              if ($scope.acknowledge == false) {
                $('#agree-to-terms-and-conditions').prop('checked', true);
              }
            };

            // console.log('@directive.paymentOptions LOADED');
            // console.log('@directive.paymentOptions:@scope.delegate ', $scope.delegate);
            // console.log('@directive.paymentOptions:@scope.config ', typeof $scope.config);

            // TODO:
            // handle usage without a rootForm

            //
            //--- INITS ----------------------------------------------
            //

            $scope.conf = $scope.config || {};
            $scope.today = new Date();
            $scope.firstMonth = 1;
            $scope.setRange = function(min, max) {
              var months = [];
              for (var i = min; i <= max; i++) months.push(i);
              return months;
            };
            // $scope.firstMonth = 1;
            $scope.currentYear = new Date().getFullYear();

            $scope.bankCodes = bankCodes;

            uteSemafoneService.clearData();

            $scope.pac = $scope.props.pac || {};
            $scope.invoice = $scope.props.invoice || {};
            $scope.pacc = $scope.props.pacc || {};

            $scope.pacc.ccMasked = $scope.props.pacc.ccMasked || '';

            $scope.paymentOptions = {
              selectedType: ''
            };

            // for invoice
            $scope.formInvoiceRules = {};
            $scope.transitNumber = true;

            $scope.ccType = null; // used to show credit card type

            //
            //--- RULES ----------------------------------------------
            //

            // for pac
            $scope.formPacRules = {
              transitCode: {},
              bankCode: {},
              accountNumber: {},
              ccTnc: {}
            };

            // for pacc
            $scope.ccType = null; // used to show credit card type

            $scope.formPaccRules = {
              // important: ccNumber is removed in the rules to allow dynamic ng-pattern regex depending on the ccType
              // ccNumber: {pattern: '([0-9]{4}[ -]?){4}'},

              // ccExpiryMonth: {type: 'number', min: 1, max: 12},
              // ccExpiryYear: {max: 4},
              cvv: {
                type: 'number'
              },

              nameOnCard: {},
              ccTnc: {}
            };

            $scope.ccNumberPatterns = {
              VISA: '(^\\d{16}$)|(^\\d{4}\\ [0-9]{4}\\ [0-9]{4}\\ [0-9]{4}$)|(^\\d{4}-\\d{4}-\\d{4}-\\d{4})',
              AMEX: '(^\\d{15}$)|(^\\d{4}\\s\\d{6}\\s\\d{5}$)|(^\\d{4}-\\d{6}-\\d{5}$)',
              MASTER:
                '(^\\d{4}\\d{4}\\d{4}\\d{4}$)|(^\\d{4}\\ \\d{4}\\ \\d{4}\\ \\d{4}$)|(^\\d{4}-\\d{4}-\\d{4}-\\d{4})',
              DEFAULT: '([0-9]{4}[ -]?){4}'
            };

            //
            //--- METHODS ----------------------------------------------
            //

            if ($scope.delegate === 'buy') {
              $scope.hasCreditCard = function() {
                var _firstId = $scope.data.creditCheck.data.firstIdOption,
                  _secondId = $scope.data.creditCheck.data.secondIdOption;
                return _.includes([_firstId, _secondId], '1');
              };
            }

            $scope.validateField = function(fieldName) {
              /*
               * handle: server response error form validations
               * handle: error code pac 60003
               */
              if (
                $scope.props.selectedPaymentOption &&
                $scope.props.selectedPaymentOption !== '' &&
                $scope.rootForm.$submitted
              ) {
                switch ($scope.props.selectedPaymentOption) {
                  case 'pac':
                    if (fieldName && fieldName === 'transitCode') {
                      $scope.rootForm.formPac.transitCode.$setValidity('invalidTransitCode', true);
                    }

                    if (fieldName && fieldName === 'bankCode') {
                      $scope.rootForm.formPac.bankCode.$setValidity('invalidBankCode', true);
                    }
                    console.log('### ', $scope, fieldName);
                    break;
                  default:
                }
              }
            };

            $scope.validateExpiryDate = function(selectedObj, idForm) {
              if ($scope.pacc.ccExpiryMonth && $scope.pacc.ccExpiryYear) {
                if ($scope.pacc.ccExpiryYear == new Date().getFullYear()) {
                  idForm.$setValidity('invalidDate', parseInt($scope.pacc.ccExpiryMonth) > new Date().getMonth());
                } else {
                  idForm.$setValidity('invalidDate', true);
                }
              }
            };

            $scope.range = function(min, max, step) {
              step = step || 1;
              var input = [];
              for (var i = min; i <= max; i += step) input.push(i);

              for (var j = 0; j < input.length - 3; ++j) {
                if (input[j] > 0 && input[j] < 10) input[j] = '0' + input[j].toString();
              }
              return input;
            };

            $scope.isSelectedPaymentMethod = function(method) {
              console.log('@isSelectedPaymentMethod:$scope ', $scope);

              if ($scope.data.paymentOptions && $scope.data.paymentOptions.submitted && !buyService.getCheckoutMode()) {
                $scope.pacc = $scope.props.pacc = {};
                $scope.props.pacc.ccMasked = '';
                $scope.pac = {};
                $scope.invoice = {};
              }

              // EC-2508 EC-48:Not able to view previously entered PAC/PACC details in Payment options page
              // $scope.pac = {};
              // $scope.pacc = {};
              // $scope.invoice = {};
              // $scope.props.pacc.ccType = '';

              $scope.$emit('PaymentOptions:SelectedMethod', {
                selectedPaymentMethod: $scope.props.selectedPaymentOption
              });
            };
            $scope.isNewPACCToggle = false;

            $scope.togglePACCForm = function() {
              $scope.isNewPACCToggle = !$scope.isNewPACCToggle;

              if ($scope.isNewPACCToggle) {
                console.log('should clear input');
                $scope.pacc = {};
              }

              console.log('@nue:paymentOptions:togglePACCForm() ', $scope.isNewPACCToggle, $scope.props, $scope);

              $scope.$emit('PaymentOptions:Events:NewCC', {
                isNewPACC: $scope.isNewPACCToggle
              });
            };

            $scope.isValidBankCode = function(bankCode) {
              if (bankCode && bankCode in bankCodes) {
                $scope.bankName = bankCode in bankCodes ? bankCodes[bankCode] : '000';
                angular.extend($scope.pac, {
                  bankName: $scope.bankName
                });
              } else {
                $scope.rootForm.formPac.bankCode.$setValidity('required', bankCode in bankCodes);
              }
            };

            $scope.setCCType = function(evt, input) {
              var ccNumber = evt.target.value;
              // console.log(ccNumber);
              if (ccNumber.length > 3) {
                if (ccNumber.match(/^(34|37)/)) {
                  $scope.props.pacc.ccType = 'AMEX';
                } else if (ccNumber.match(/^(4|13)/)) {
                  $scope.props.pacc.ccType = 'VISA';
                } else if (ccNumber.match(/^5[1-5]/)) {
                  $scope.props.pacc.ccType = 'MASTER';
                } else {
                  /*
                   * @else
                   * @param input => ngModelController Object
                   * Set input invalid with error as required
                   * if input value did not fall under given regex types of ccards
                   *
                   */

                  input.$setValidity('required', false);
                  $scope.props.pacc.ccType = 'DEFAULT';
                }
              } else if (ccNumber.length < 3) {
                $scope.props.pacc.ccType = '';
              }
            };

            $scope.validateMethod = function(methodSelected) {
              if (!methodSelected) {
                $scope.$emit('methodValidatedError', {
                  type: methodSelected
                });
                return;
              }

              // console.log(Object.keys($scope.rootForm[methodSelected].$error), $scope);

              if ($scope.delegate === 'my-account') {
                // @if block
                // handle validateMethod call on my-account > change-payment-method

                // handle invalid form
                if ($scope.rootForm[methodSelected].$invalid) {
                  Object.keys($scope.rootForm[methodSelected].$error).forEach(function(key) {
                    // => show error messages
                    $scope.rootForm[methodSelected].$setSubmitted();

                    $scope.rootForm[methodSelected].$error[key].forEach(function(control) {
                      control.$setTouched(); // no $setDirty function
                    });
                  });

                  if (
                    uteSemafoneService.getMaskedCardNumber() == null ||
                    uteSemafoneService.getMaskedCardNumber() == ''
                  ) {
                    $scope.isNotValidCard = true;
                    if (methodSelected === 'formPacc') {
                      $translate('global.error.inline.creditCard.numberInvalid').then(function(translatedValue) {
                        dtmService.fireDtmExceptions(
                          dtmServiceConstants.dtmRules.updateMOP.name,
                          [translatedValue],
                          'CS'
                        );
                      });
                    }
                  }
                  return;
                }
              } else if ($scope.delegate === 'buy') {
                console.log('ONE');

                //@elseif block
                //handle validateMethod call on payment-options in checkout

                if (methodSelected !== 'formPacc') {
                  // on scenarios: pac & invoice
                  // handle invalid form

                  if ($scope.rootForm[methodSelected].$invalid) {
                    Object.keys($scope.rootForm[methodSelected].$error).forEach(function(key) {
                      // => show error messages
                      $scope.rootForm[methodSelected].$setSubmitted();

                      $scope.rootForm[methodSelected].$error[key].forEach(function(control) {
                        control.$setTouched(); // no $setDirty function
                      });
                    });
                    return;
                  }
                } else if (methodSelected === 'formPacc') {
                  $scope.rootForm[methodSelected].$setSubmitted();

                  // @elseif block
                  // handle submit when user entered cc on previous step and procceeding
                  // and form is valid

                  if ($scope.rootForm[methodSelected].cvv.$valid && $scope.hasCreditCard()) {
                    if ($scope.hasCreditCard() && !$scope.isNewPACCToggle) {
                      // if toggle is false (user submit using the previous credit card from previous step) => proceed to submit with previous cc
                      console.log('masked number:' + uteSemafoneService.getMaskedCardNumber());
                      $scope.$emit('methodValidated', {
                        type: 'pacc',
                        data: {
                          ccNumber: uteSemafoneService.getToken(),
                          ccExpiryYear: $scope.props.pacc.ccExpiryYear,
                          ccExpiryMonth: $scope.props.pacc.ccExpiryMonth,
                          ccType: $scope.props.pacc.ccType,
                          cvv: $scope.pacc.cvv
                        }
                      });
                      return;
                    }
                  } else if ($scope.rootForm[methodSelected].cvv.$invalid) {
                    //@elseif block
                    //handle submit on and invalid form where user entered an invalid cvv no

                    $scope.rootForm[methodSelected].$setSubmitted();
                    //DSO-12647 scroll to the first error
                    var errorCheckCCNumber = uteSemafoneService.getToken();
                    if (
                      (errorCheckCCNumber == null || errorCheckCCNumber == '') &&
                      (!$scope.hasCreditCard() || $scope.isNewPACCToggle)
                    ) {
                      $scope.isNotValidCard = true;
                    }
                    return;
                  } else if (!$scope.hasCreditCard() && $scope.rootForm[methodSelected].$invalid) {
                    //@elseif
                    //handle submit on no credit card on previous steps and form is invalid

                    $scope.rootForm[methodSelected].$setSubmitted();
                    return;
                  }
                }
              }

              switch (methodSelected) {
                case 'formInvoice':
                  console.log('@validateMethod:INVOICE');

                  $scope.$emit('methodValidated', {
                    type: 'invoice',
                    data: {}
                  });
                  break;
                case 'formPac':
                  console.log('@validateMethod:PAC');

                  $scope.$emit('methodValidated', {
                    type: 'pac',
                    data: $scope.pac
                  });
                  break;
                case 'formPacc':
                  console.log('@validatemethod:PACC: ($scope)', $scope);

                  // send cc number to cybersource for validation
                  /*  uteCyberSource.getEncryptedToken($scope.pacc.ccNumber.toString()).then(function (resp) {
                                    var encrypted = resp.data;

                                    if (encrypted.rc === '100') {
                                      uteCyberSource.getDecryptedToken(encrypted, encrypted.cardType).success(function(data){
                                        if (data.decrypt){

                                          // $scope.isNewPACCToggle = false;
                                          $scope.$emit('methodValidated',
                                                      { type: 'pacc',
                                                        data: { decrypted: $scope.pacc,
                                                                encrypted: encrypted,
                                                                maskedToken: uteCyberSource.getMaskedToken(data.decrypt),
                                                                token: data.decrypt,
                                                                ccType: buyUtils.getCCType().byFirstChar(encrypted.cardType),
                                                                ccNumber: data.decrypt,
                                                                ccExpiryMonth: $scope.pacc.ccExpiryMonth,
                                                                ccExpiryYear: $scope.pacc.ccExpiryYear,
                                                                cvv: $scope.pacc.cvv
                                                              }});
                                        }
                                      }, function(err){
                                      });
                                    } else {
                                      $scope.$emit('methodValidatedError', { type: 'pacc', msg: 'Invalid CC.' });
                                    }
                                  }, function(){
                                    $scope.$emit('methodValidatedError', { type: 'pacc', msg: 'Something went wrong while trying to validate CC.' });*/
                  // });
                  if (
                    uteSemafoneService.getMaskedCardNumber() == null ||
                    uteSemafoneService.getMaskedCardNumber() == ''
                  ) {
                    $scope.$emit('methodValidatedError', { type: 'pacc', msg: 'The card number is invalid' });
                    // alert("The card number is invalid");
                  } else {
                    var ccType = uteSemafoneService.getCardScheme();

                    if (ccType === 'MASTERCARD') {
                      ccType = 'MASTER';
                    }

                    $scope.$emit('methodValidated', {
                      type: 'pacc',
                      data: {
                        ccNumber: uteSemafoneService.getToken(),
                        ccExpiryMonth: $scope.pacc.ccExpiryMonth,
                        ccExpiryYear: $scope.pacc.ccExpiryYear,
                        cvv: $scope.pacc.cvv,
                        ccType: ccType
                      }
                    });
                  }

                  break;
              }
            };

            // set method to validate form
            $scope.$on('validateMethod', function(ev, data) {
              console.log('@paymentOptions:validateMethod ', $scope.props.selectedPaymentOption, data);

              switch ($scope.props.selectedPaymentOption) {
                case 'invoice':
                  $scope.validateMethod('formInvoice');
                  break;
                case 'pac':
                  $scope.validateMethod('formPac');
                  break;
                case 'pacc':
                  $scope.validateMethod('formPacc');
                  break;
                default:
                  // console.log('default method...');
                  $scope.$emit('methodValidatedError', {
                    type: $scope.paymentOptions.selectedType
                  });
              }
            });

            // select payment option type if user previously selected one
            $scope.$on('setSelectedPaymentOption', function(ev, data) {
              console.log('@paymentOptions:$on.setSelectedPaymentOption', data, $scope);
              $scope.props.selectedPaymentOption = data.type;
              $scope.isSelectedPaymentMethod(data.type); //BY HP
            });
          };
        }
      };
    }
  ]);
})();
